<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11NUD4r/Images/cover.jpg?1684514918089" alt="This image is the cover for the book La rançon, Série Royal Navy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">La rançon, Série Royal Navy
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Série Royal Navy, tome 1</i></b></p><p>Un officier, un gentleman… et un sodomite. Si les deux premiers titres inspirent honneur et respect, le troisième pourrait coûter la vie à David Archer. Il réalise sans espoir son attirance pour le nouvel aspirant, William Marshall, lorsque ce dernier défie en duel le prédateur sexuel du bord – et le tue.</p> <p>Marshall considère la Royal Navy comme sa seule chance d’échapper à ses modestes origines. Pendant que d’autres passent leurs jours de congé à ripailler, il étudie avec acharnement. Enlevés par un renégat, les deux amis et leur capitaine deviennent les pions d’un jeu sadique. Pour protéger celui qu’il aime, David Archer choisit d’affronter ses démons et de se soumettre à de nouveaux abus. En apprenant ce sacrifice, Marshall réalise que ses sentiments dépassent la simple amitié. Amoureux pour la première fois de sa vie, il tient à exprimer sa passion pour Davy.</p> <p>D’abord, ils doivent s’évader. Ensuite, il leur faudra trouver le moyen de préserver leur secret sans le payer de leur vie.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lee Rowan, Anne Solo
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0de5ccb7